import { Box, Typography } from '@mui/material'

function ComingSoon() {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        p: 4,
      }}
    >
      <Typography color="text.secondary" variant="h6">
        Coming soon
      </Typography>
    </Box>
  )
}

export default ComingSoon
